import { IIndexable } from 'core-ts-types';
import * as _4 from 'lodash4';

export class MajorCredential implements IIndexable {
  id: number;
  nk: string;
  short_credential: string;
  degree_level: number;
  desc: string;

  constructor(credential: Partial<MajorCredential>) {
    _4.merge(this, credential);
  }

  static build(credential: Partial<MajorCredential>): MajorCredential {
    return new MajorCredential(credential);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/builders/major_credential_builder.ts